import { GlobalSettings } from "@/models/global.model";
import { AnswserQuestion } from "@/models/questions.model";
import { Settings, TypeOfContainement } from "@/models/settings.model";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import store from "..";
import {
  UPDATE_ANSWERS,
  ACTION_INIT_DEFAULT_SETTINGS,
  UPDATE_DEPRESSION_TO_MAINTAIN,
  UPDATE_DUST_LEVEL,
  UPDATE_MIN_DEPRESSION,
  UPDATE_RENEWAL_RATE,
  UPDATE_SETTINGS,
  RESET_SETTINGS,
} from "../operators";

const initialSettings: Settings = {
  dustLevel: 0,
  siteLevel: 0,
  renewalRate: 0,
  leakRate: 0,
  isLeakRatePrecise: true,
  minimumRenewalRate: 0,
  minimalDepressionValue: 0,
  depressionValuetoMaintain: 0,
  typeOfContainement: TypeOfContainement.TypeI,
  estimedLeakRate: 0,
  answers: [],
};

/**
 * This module contains params calculated from user inputs
 */
@Module
export default class SettingsStore extends VuexModule {
  // site variables
  public settings: Settings = initialSettings;

  @Mutation
  public [UPDATE_DEPRESSION_TO_MAINTAIN](value: number): void {
    this.settings.depressionValuetoMaintain = value;
  }

  @Mutation
  public [UPDATE_DUST_LEVEL](value: number): void {
    this.settings.dustLevel = value;
  }

  @Mutation
  public [UPDATE_RENEWAL_RATE](value: number): void {
    this.settings.renewalRate = value;
  }

  @Mutation
  public [UPDATE_MIN_DEPRESSION](value: number): void {
    this.settings.minimalDepressionValue = value;
  }

  @Mutation
  public [UPDATE_ANSWERS](value: AnswserQuestion[]): void {
    this.settings.answers = value;
  }

  @Mutation [UPDATE_SETTINGS](value: Settings): void {
    this.settings = value;
  }

  @Action [ACTION_INIT_DEFAULT_SETTINGS](value: GlobalSettings): void {
    store.commit(UPDATE_DEPRESSION_TO_MAINTAIN, value.defaultDepression);
    store.commit(UPDATE_DUST_LEVEL, value.dustLevelMin);
    store.commit(UPDATE_MIN_DEPRESSION, value.minimumDepression);
    store.commit(UPDATE_RENEWAL_RATE, value.minimumRenewalRate);
  }

  @Action [RESET_SETTINGS](value: GlobalSettings): void {
    store.commit(UPDATE_SETTINGS, initialSettings);
    store.dispatch(ACTION_INIT_DEFAULT_SETTINGS, value);
  }
}
